import React, { useState } from 'react';
import ZoneManagerMap from '../../../components/ZoneManagerMap';
import { styles } from './adminStyles';
import { resolveActiveLayerName } from './layerUtils';

const GlobalEligibilityPanel = ({ globalZones, eligibilityLayers, onApplyExisting }) => {
  const [selectedLayerId, setSelectedLayerId] = useState('');
  const [isBusy, setIsBusy] = useState(false);
  const [status, setStatus] = useState('');

  const activeLayerLabel = resolveActiveLayerName(globalZones, eligibilityLayers);

  const handleApply = async () => {
    if (!selectedLayerId) return;
    if (!window.confirm("⚠️ WARNING: This replaces your organisation's active Global Eligibility layer. Continue?")) return;
    setIsBusy(true); setStatus('');
    try {
      await onApplyExisting(selectedLayerId);
      setStatus('✅ Global Eligibility Layer Updated!');
      setTimeout(() => setStatus(''), 3000);
    } catch (err) {
      setStatus('❌ Apply Failed: ' + (err.response?.data?.msg || 'Error'));
    } finally { setIsBusy(false); }
  };

  return (
    <div style={{...styles.card, marginBottom: 0}}>
      <h2 style={{marginTop:0, ...styles.h2}}>Global Eligibility</h2>
      <p style={{...styles.textMuted, fontSize:'0.9rem', marginTop:'-5px', marginBottom: '15px'}}>
        Defines the base boundary within which farmers in your organisation can bid. Applies across all of your events.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '350px 1fr', gap: '30px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

          <div style={{padding:'15px', background:'#F8FAFC', borderRadius:'5px', border:'1px solid #ddd'}}>
            <h4 style={{marginTop:0, fontSize:'0.95rem', color:'#0F172A', fontFamily: '"Plus Jakarta Sans", sans-serif'}}>Select Existing Layer</h4>
            <p style={{fontSize:'0.8rem', color:'#64748B', marginTop:0}}>
              New layers are uploaded from the Layer Library above, then applied here.
            </p>
            <select
              style={styles.select}
              value={selectedLayerId}
              onChange={(e) => setSelectedLayerId(e.target.value)}
              disabled={isBusy}
            >
              <option value="">-- Choose a saved layer --</option>
              {eligibilityLayers.map(l => (
                <option key={l._id} value={l._id}>{l.name}</option>
              ))}
            </select>
            <button
              type="button"
              disabled={isBusy || !selectedLayerId}
              onClick={handleApply}
              style={{...styles.btnPrimary, width:'100%', opacity: (isBusy || !selectedLayerId) ? 0.6 : 1, cursor: (isBusy || !selectedLayerId) ? 'not-allowed' : 'pointer'}}
            >
              Apply Selected Layer
            </button>
            {status && <div style={{ marginTop: '10px', fontSize:'0.85rem', fontWeight: 'bold', color: status.includes('Failed') ? '#F59E0B' : '#0D9488' }}>{status}</div>}
          </div>
        </div>

        <div style={{ backgroundColor: '#FFFFFF', borderRadius: '8px', border: '1px solid #eee', padding: 0, overflow: 'hidden', minHeight: '500px', display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '10px 15px', borderBottom: '1px solid #eee', backgroundColor: '#F8FAFC', fontSize: '0.85rem', color: '#475569', fontFamily: '"Inter", sans-serif' }}>
            <strong style={{color: '#0F172A'}}>Active Layer:</strong> {activeLayerLabel}
          </div>
          <div style={{flex: 1, position: 'relative'}}>
            <ZoneManagerMap zones={globalZones} layerType="eligibility" loading={isBusy} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalEligibilityPanel;
